<template>
  <form @submit.prevent="addRateInterest" method="post">
    <b-row>
      <b-col cols="12" sm="12">
        <b-card>
          <div slot="header">
            <strong>{{caption}}</strong>
          </div>
          <b-row>
            <b-col sm="12">
              <b-form-group>
                <label for="txtValor">Valor</label>
                <b-form-input
                  type="number"
                  id="txtValor"
                  v-model="rateInterest.interes"
                  step="0.01"
                  min="0.00"
                  max="100.00"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <b-form-group>
                <label for="txtFechaInicio">Fecha inicio</label>
                <b-form-input type="date" id="txtFechaInicio" v-model="rateInterest.start_date"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <b-form-group>
                <label for="txtFechaFin">Fecha fin</label>
                <b-form-input type="date" id="txtFechaFin" v-model="rateInterest.end_date"></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>

          <b-button @click="goBack" variant="primary" class="mr-1">Cancelar</b-button>

          <b-button type="submit" variant="success">Guardar</b-button>
        </b-card>
      </b-col>
    </b-row>
  </form>
</template>

<script>
export default {
  name: "rateInterestAdd",
  props: {
    caption: {
      type: String,
      default: "Tasa de Interés",
    },
  },
  data: () => {
    return {
      token: localStorage.getItem("token"),
      rateInterest: {
        interes: "",
        start_date: "",
        end_date: "",
      },
      datos: [],
    };
  },
  mounted() {},
  computed: {},
  methods: {
    addRateInterest() {
      showLoader();
      this.datos = JSON.stringify(this.rateInterest);

      this.$http
        .post(`${this.$urlApi}rateInterests?token=${this.token}`, this.datos, {
          headers: { "Content-Type": "application/json" },
        })
        .then(function (response) {
          console.log(response);

          hideLoader();

          this.$swal({
            title: "Buen trabajo",
            text: "Registro guardado correctamente!",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          }).then((result) => {
            if (result.value) {
              location.href = `${location.origin}/#/rateInterests`;
            }
          });
        })
        .catch((error) => {
          console.log(error.body.error);
          alert(error.body.error);
          hideLoader();
        });
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
